export default {"src":"/_next/static/media/carWithPatchPlayground2LightBg_104.f738c739.svg","height":104,"width":104,"blurWidth":0,"blurHeight":0};